import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';

import env from '@/env';
import { Certificate } from '@/features/client-certificates/types';

export const getCertificateById = async (id: string): Promise<Certificate> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/certificates/${id}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as Certificate;
  return response;
};
